import { lazy } from "react";

export { WEEKEND_WORK_REQUESTS_PATH } from "./path";
export const WeekendWorkRequestsPage = lazy(() => import("./page"));
